import { useEffect } from "react";
import ContactUs from "./ContactUs";

function ContactPopUp() {
  function closeContactPopUp() {
    document.querySelector(".contactPopUp").style.zIndex = "-100";
    document.querySelector(".contactPopUp").style.transform = "scale(0)";
    setTimeout(
      () => (document.querySelector(".contactPopUp").style.display = "none"),
      500
    );
    document.querySelector(".captchaCont").style.pointerEvents = "none";
  }

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === "Escape") {
        closeContactPopUp();
      }
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <div className="contactPopUp">
      <i
        className="fa-sharp fa-solid fa-xmark contactClose"
        onClick={closeContactPopUp}
      ></i>
      <ContactUs />
    </div>
  );
}

export default ContactPopUp;
